import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ImportarScreen from './screen';
import { useNotifications} from '../../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import { PeriodosAdapter } from '../../../../../../infraestructure/persistence/rest/PeriodosAdapter';

// interface PeriodoContenidoEntity
// {
//     IdTipoContenido: string,
//     TipoContenido: string,
//     IdVersion: number
// }

export const DescargarPlantillaContainer = () => {

	const api = new PeriodosAdapter();
	const { exceptionError, resultError } = useNotifications();
	let result: any;
	let [año, setAño] = useState<any>(undefined);
	let [reunion, setReunion] = useState<any>(undefined);

	useEffect(()=>{
		getTiposContenido();
	  },[])
	
		const getTiposContenido = async () => {
			try {
				result = await api.getTiposContenidoUltimoPeriodoCerrado();
				if(result.data && result.data!=="")
				{
					var data = ([ ...result.data ] || []);
					if(data.length > 0){
						setAño(([ ...result.data ] || [])[0].año);
						setReunion(([ ...result.data ] || [])[0].reunion);
					}else{
						setAño(undefined);
						setReunion(undefined);
					}
				}else{resultError()}
			} catch (error) {
				let exception = ServerErrorMessage(error);
				exceptionError(exception)
			}
	  };

	return (
		<>
			<ImportarScreen año={año} reunion={reunion} />
		</>
	);
};

export default DescargarPlantillaContainer;
